import { render, staticRenderFns } from "./sortSimilar.vue?vue&type=template&id=a9f76100&"
import script from "./sortSimilar.vue?vue&type=script&lang=js&"
export * from "./sortSimilar.vue?vue&type=script&lang=js&"
import style0 from "./sortSimilar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports